
;( function( window, document ) {

	$.fn.mediaManagerObjects = [];

	$.fn.mediaManager = function( input ) {

		/**
		 * [ImagePlaceholder description]
		 * @param {[type]} elm     [description]
		 * @param {[type]} options [description]
		 */
		var ImagePlaceholder = function( elm, options )
		{
			var single = this;
			elm.hide();
			this._elm = elm;
			this.placeholder = $( '<div />' ).addClass( 'media-placeholder' );
			this.buttons = $( '<div />' ).addClass( 'btn-group' );
			this.remove = $( '<button />' ).addClass( 'btn btn-danger' ).text( 'remove' ).appendTo( this.buttons );
			this.browse = $( '<button />' ).addClass( 'btn btn-info' ).text( 'browse' ).appendTo( this.buttons );

            if( ! options.foldersOnly ) {
                this.noneSelected = $('<div />').addClass('no-media').append($('<i />').addClass('file image outline icon')).prependTo(this.placeholder).css({
                    width: options.width + 'px',
                    height: options.height + 'px',
                    maxWidth: '100%',
                    maxHeight: '100%'
                });
            } else {
            	this.textContainer = $('<p>No folder selected...</p>').addClass('folder-text').appendTo(this.placeholder);
			}

			this.buttons.appendTo( this.placeholder );
			this.placeholder.insertBefore( elm );

			this.browse.bind( 'click.gmm', function(e) {
				e.preventDefault();
                if( options.foldersOnly ) {
                    document.MMGLOB.folderSelect();
                }
				if( options.restrictions ) {
					document.MMGLOB.setFileTypeRestrictions([ 'png', 'jpg', 'jpeg', 'gif' ]);
				}
				document.MMGLOB.setBrowser( single );
			});

			this.remove.bind( 'click.gmm', function(e) {
				e.preventDefault();
                if( ! options.foldersOnly ) {
                    single.noneSelected
                        .removeClass('has-selected').css({
                        'background-image': ' none'
                    });
                } else {
                    single.textContainer.text( 'No folder selected...' );
				}
				single._elm.val( 0 );
			});

            /**
			 * Selected Folder Callback
             * @param folder
             */
			this.selectedFolder = function( folder )
			{
                single._elm.val( folder.id );
				this.textContainer.text( folder.name );
			};

            /**
			 * On Load Folder
             * @param folder
             */
			this.onLoadFolder = function( folder )
			{
                single.textContainer.text( folder.name );
			};

			/**
			 * [selectedMedia description]
			 * @param  {[type]} media [description]
			 * @return {[type]}       [description]
			 */
			this.selectedMedia = function( media )
			{
                single.noneSelected.addClass( 'loading' );
				var tmpImage = new Image();
                tmpImage.media = media;
				tmpImage.onload = function() {
                    single.noneSelected
                    .addClass( 'has-selected' )
					.removeClass( 'loading' )
					.css({
                    	'background-image' : 'url("/admin/media-manager/alter-image/crop/' + options.width + '/' + options.height + '/' + media.name.replace( /\s/, '%20' ) + '.' + media.extension + '")'
                    });
                };
				tmpImage.src = '/admin/media-manager/alter-image/crop/' + options.width + '/' + options.height + '/' + media.name.replace( /\s/, '%20' ) + '.' + media.extension;
				single._elm.val( media.id );
			};

			if( parseInt( this._elm.val() ) ) {
                if( ! options.foldersOnly ) {
                    document.MMGLOB.getMediaInfo(parseInt(this._elm.val()), this.selectedMedia);
                } else {
                    document.MMGLOB.getFolderInfo(parseInt(this._elm.val()), this.onLoadFolder);
				}
			}

			elm.data( 'MMSINGLE', this );

		};

		/**
		 * [AllMediaPlaceholder description]
		 * @param {[type]} elm     [description]
		 * @param {[type]} options [description]
		 */
		var AllMediaPlaceholder = function( elm, options )
		{
			var single = this;
			elm.hide();
			this._elm = elm;
			this.placeholder = $( '<div />' ).addClass( 'media-placeholder' );
            this.buttons = $( '<div />' ).addClass( 'btn-group' );
            this.remove = $( '<button />' ).addClass( 'btn btn-danger' ).text( 'remove' ).appendTo( this.buttons );
            this.browse = $( '<button />' ).addClass( 'btn btn-info' ).text( 'browse' ).appendTo( this.buttons );

			if( ! options.foldersOnly ) {
                this.noneSelected = $('<div />').addClass('no-media').append($('<i />').addClass('file image outline icon')).prependTo(this.placeholder).css({
                    width: options.width + 'px',
                    height: options.height + 'px',
                    maxWidth: '100%',
                    maxHeight: '100%'
                });
            }

			this.buttons.appendTo( this.placeholder );
			this.placeholder.insertBefore( elm );

			this.browse.bind( 'click.gmm', function(e) {
				e.preventDefault();
				document.MMGLOB.setFileTypeRestrictions([]);
				document.MMGLOB.setBrowser( single );
			});

			this.remove.bind( 'click.gmm', function(e) {
				e.preventDefault();
                if( ! options.foldersOnly ) {
                    single.noneSelected
                        .removeClass('has-selected').css({
                        'background-image': ' none'
                    });
                }
				single._elm.val( 0 );
			});

			/**
			 * [selectedMedia description]
			 * @param  {[type]} media [description]
			 * @return {[type]}       [description]
			 */
			this.selectedMedia = function( media )
			{
                if( ! options.foldersOnly ) {
                    single.noneSelected
                        .addClass('has-selected').css({
                        'background-image': 'url(/admin/media-manager/alter-image/crop/' + options.width + '/' + options.height + '/' + media.name + '.' + media.extension + ')'
                    });
                }
				single._elm.val( media.id );
			};

			if( parseInt( this._elm.val() ) ) {
				document.MMGLOB.getMediaInfo( parseInt( this._elm.val() ), this.selectedMedia );
			}

			elm.data( 'MMSINGLE', this );

		};

		/**
		 * [MediaManager description]
		 * @param {[type]} elm   [description]
		 * @param {[type]} input [description]
		 */
		var MediaManager = function( elm, input ) {

			var options = { 
				type : 'images', 
				value : 0,
				width: 300,
				height: 150,
				restrictions : true,
				foldersOnly : false
			};
			if( typeof input === 'object' ) options = $.extend( options, input );
			var _elm = $(elm);

			/** hack for previous version */
			if( _elm.attr( 'data-media-type' ) ) options.type = _elm.attr( 'data-media-type' );
			if( _elm.attr( 'data-width' ) ) options.width = parseInt( _elm.attr( 'data-width' ) );
			if( _elm.attr( 'data-height' ) ) options.height = parseInt( _elm.attr( 'data-height' ) );
            if( _elm.attr( 'data-folders' ) ) options.foldersOnly = _elm.attr( 'data-folders' ) === 'true';
			if( _elm.val() ) options.value = parseInt( _elm.val() );

			switch( options.type ) {
				case 'images' :
					$.fn.mediaManagerObjects.push( new ImagePlaceholder( _elm, options ) );
				break;
				default :
					$.fn.mediaManagerObjects.push( new AllMediaPlaceholder( _elm, options ) );
				break;
			}

		};

		/**
		 * [GlobalMediaManager description]
		 */
		var GlobalMediaManager = function()
		{

			var MAX_FILE_SIZE = window.max_upload_size;

			var FILE_TYPE_ERROR = 'The file type is not permitted.';

			var MAX_FILE_SIZE_ERROR = 'The files size is too large.';

			var permitted = [
				'image/svg+xml',
				'image/jpeg',
				'image/gif',
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'image/png',
				'application/pdf',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
			];

			var gmm = this;

			var api;

			var folder_id = 0;

			var searchRequest = null;

			var elmBrowsing = null;

			var fileTypeRestrictions = [];

			var redactorInstance = null;

			this.overlay = $('<div />').addClass( 'global media manager overlay' ).appendTo( $( 'body' ) ).fadeOut(0);

			this.modal = $('<div />').addClass( 'global media manager modal' ).appendTo( $( 'body' ) ).fadeOut(0);

			this.error = null;

			this.browserView = null;

			this.closeButton = null;

			this.dropZone = null;

			this.uploadList = null;

			this.previous_folder_id = null;

			this.media_editting = null;

			this.folder_id = 0;

			this.folder_editting = null;

			this.cardBeingDragged = null;

			this.toBeDeleted = null;

			this.search_bar = null;

			this.search_for = 1;

			this.current_view = 0; /** 0: Grid, 1: List **/

			this.updateInterval = null;

			this.images = {};

			this.loader = null;

			this.foldersSelect = false;

			var displayErrorMessage = function( message )
			{
				$( 'p', gmm.error ).html( message );
				gmm.error.fadeIn( 200 );
			};

			/**
			 * [closeErrorMessage description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var closeErrorMessage = function(e)
			{
				( e ? e.preventDefault() : null );
				gmm.error.fadeOut(200);
			};

			/**
			 * [toggleView description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var toggleView = function(e)
			{
				( e ? e.preventDefault() : null );
				$( '.icon', $( this ) ).toggleClass( 'list grid' );
				gmm.current_view = ( gmm.current_view == 0 ? 1 : 0 );
				getModalPartial( function( view ) {
					updateBrowserView( view );
				});
			}

			/**
			 * [closeButton description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var closeModal = function(e)
			{
				( e ? e.preventDefault() : null );
				api.close();
			};

			/**
			 * [editDetailsModal description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var editDetailsModal = function(e)
			{
				e.preventDefault();
				getMediaInfo( parseInt( $(this).parents( '[data-for="card"]:eq(0)' ).attr( 'data-media-id' ) ), function( model ){
					gmm.media_editting = model.id;
					$( '[data-name="alt-text"]', $( '[data-for="browse-panel"]' ) ).val( model.alt_text );
					$( '[data-name="name"]', $( '[data-for="browse-panel"]' ) ).val( model.name );
					var tags = '';
					model.grouping_tags.forEach( function( tag ) {
						tags += tag.name + ',';
					});
					$( '[data-name="tags"]' ).importTags(tags);
					if( model.is_image ) {
                        $( '[data-for="focal-point-img"]', $( '[data-for="browse-panel"]' ) ).attr( 'src', model.full_path );
                        $( '[data-for="x-focal-point"]', $( '[data-for="browse-panel"]' ) ).val( model.x_focal_point );
                        $( '[data-for="y-focal-point"]', $( '[data-for="browse-panel"]' ) ).val( model.y_focal_point );
                        $('.focal-pointer').css({
							left : model.x_focal_point + '%',
                            top : model.y_focal_point + '%',
						});
					}

					$( '[data-for="browse-panel"]' ).toggleClass( 'modal' );
				});
			};

			/**
			 * [editFolderModal description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var editFolderModal = function(e)
			{
				e.preventDefault();
				getFolderInfo( parseInt( $(this).parents( '[data-for="folder"]:eq(0)' ).attr( 'data-id' ) ), function( model ){
					gmm.folder_editting = model.id;
					$( '[data-name="edit-folder-name"]', $( '[data-for="browse-panel"]' ) ).val( model.name );
					$( '[data-for="browse-panel"]' ).toggleClass( 'folder-edit-modal' );
				});
			};

			/**
			 * [generateTagsObject description]
			 * @param  {[type]} objs [description]
			 * @return {[type]}      [description]
			 */
			var generateTagsObject = function( objs )
			{
				var tags = [];
				objs.each( function() {
					tags.push( $( '> span', $( this ) ).text().replace( /\s+$/, '' ) );
				});
				return tags;
			};

			/**
			 * [saveMedia description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var saveMedia = function(e)
			{
				( e ? e.preventDefault() : null );
				var altText = $( '[data-name="alt-text"]', $( '[data-for="browse-panel"]' ) ).val();
				var name = $( '[data-name="name"]', $( '[data-for="browse-panel"]' ) ).val();
				var tags = generateTagsObject( $( '.meta.modal .tag' ) );
				var x_focal_point = $('[data-for="x-focal-point"]').val();
                var y_focal_point = $('[data-for="y-focal-point"]').val();
				tokenPost( '/admin/media-manager/update-media', { name : name, alt_text : altText, tags : tags, media_id : gmm.media_editting, x_focal_point : x_focal_point, y_focal_point : y_focal_point }, function( response ){
					getModalPartial( function( view ) {
						$( '[data-name="tags"]' ).importTags('');
						cancelSaveDetails();
						updateBrowserView( view );
					});
				}, function( error, data ) {
					displayErrorMessage( error.responseJSON.message );
				});
			};

			/**
			 * [cancelSaveDetails description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var cancelSaveDetails = function(e)
			{
				( e ? e.preventDefault() : null );
				$( '[data-for="browse-panel"]' ).toggleClass( 'modal' );
				closeErrorMessage();
			};

			/**
			 * [handleDroppedFiles description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var handleDroppedFiles = function(e)
			{
				var files = e.originalEvent.dataTransfer.files;
				for ( var i = 0, file; file = files[i]; i++ ) {
					new uploadFile( file );
				}
			};

			/**
			 * [singleFileUploadHandler description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var singleFileUploadHandler = function(e)
			{
				var files = e.originalEvent.target.files;
				for ( var i = 0, file; file = files[i]; i++ ) {
					new uploadFile( file );
				}
			};

			/**
			 * [uploadError description]
			 * @param  {[type]} message [description]
			 * @return {[type]}         [description]
			 */
			var uploadError = function( message, file )
			{
				alert(message);
			}

			/**
			 * [readURL description]
			 * @param  {[type]}   file     [description]
			 * @param  {Function} callback [description]
			 * @return {[type]}            [description]
			 */
			var readURL = function( file, callback ) {
				var reader = new FileReader();
				reader.onload = function(e){
					callback( e, file );
				};
				reader.readAsDataURL( file );
			};

			/**
			 * [createHtmlUploadElement description]
			 * @param  {[type]} file [description]
			 * @return {[type]}      [description]
			 */
			var createHtmlUploadElement = function( file, callback )
			{
				readURL( file, function(e, file) {
					var elm = $( '[data-tmpl="upload-item"]' ).clone().html();
					elm = elm.replace( '<% SRC %>', e.target.result );
					elm = elm.replace( '<% TEXT %>', file.name );
					callback( $( elm ) );
				});
			};

			/**
			 * [uploadFailed description]
			 * @param  {[type]} elm  [description]
			 * @param  {[type]} file [description]
			 * @return {[type]}      [description]
			 */
			var uploadFailed = function( elm, file )
			{
				scrollToTop( '.uploads.area > div' );
			};

			/**
			 * [errorTooLarge description]
			 * @param  {[type]} HTMLElement [description]
			 * @param  {[type]} file        [description]
			 * @return {[type]}             [description]
			 */
			var errorTooLarge = function( elm, file )
			{
				$( '.progress', elm ).removeClass( 'blue' ).addClass( 'error' );
				$( '.progress .label', elm ).text( $( '.progress .label', elm ).text() + ' - size too large' );
				( function( _elm ){
					setTimeout( function(){
						_elm.fadeOut( 200, function(){
							$( this ).remove();
						});
					}, 3000 );
				} )( elm );

			};

			/**
			 * [errorNotPermitted description]
			 * @param  {[type]} HTMLElement [description]
			 * @param  {[type]} file        [description]
			 * @return {[type]}             [description]
			 */
			var errorNotPermitted = function( elm, file )
			{
				console.log( elm, file );
			};

			/**
			 * [uploadFile description]
			 * @param  {[type]} file [description]
			 * @return {[type]}      [description]
			 */
			var uploadFile = function( file )
			{
				var xhr = new XMLHttpRequest();
				if ( xhr.upload ) {

					createHtmlUploadElement( file, function( elm ) {

						var HTMLElement = elm.appendTo( gmm.uploadList );
						var progressObj = $( '.ui.progress', HTMLElement );

						if( file.size >= MAX_FILE_SIZE ) return errorTooLarge( HTMLElement, file );
						if( ! $.inArray( file.type, permitted ) ) return errorNotPermitted( HTMLElement, file );

						xhr.upload.addEventListener( "progress", function(e) {
							var pc = parseInt( ( e.loaded / e.total * 100 ) );
							progressObj.progress({ percent : pc });
						}, false );

						xhr.onreadystatechange = function(e) {
							if ( xhr.readyState == 4 ) {
								progressObj.progress({ percent : 100 });
								progressObj.parents('.row:eq(0)').fadeOut( 200, function(){
									$(this).remove();
									scrollToTop( '.uploads.area > div' );
								});
								if( xhr.status !== 200 ) {
									uploadFailed( HTMLElement, file );
								} else {
									if( gmm.updateInterval !== null ) {
										clearInterval( gmm.updateInterval );
										gmm.updateInterval = null;
									}
									gmm.updateInterval = setInterval( function() {
										getModalPartial( function( view ) {
											updateBrowserView( view );
										});
										clearInterval( gmm.updateInterval );
										gmm.updateInterval = null;
									}, 1000 );
								}
							}
						};

						xhr.open( "POST", '/admin/media-manager/upload', true );
						xhr.setRequestHeader( 'X-CSRF-TOKEN', window.MediaManager.csrfToken );
						xhr.setRequestHeader( "X-FILENAME", file.name );
						xhr.setRequestHeader( "X-FOLDER-ID", gmm.folder_id );
						xhr.send( file );

					});

				} else {
					alert("File forbidden or too large");
				}
			};

			/**
			 * [createNewFolder description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var createNewFolder = function(e)
			{
				( e ? e.preventDefault() : null );
				$( '[data-for="browse-panel"]', gmm.modal ).addClass( 'folder-modal' );
			};

			/**
			 * [cancelCreateNewFolder description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var cancelCreateNewFolder = function(e)
			{
				( e ? e.preventDefault() : null );
				$( '[data-for="browse-panel"]', gmm.modal ).removeClass( 'folder-modal' );
			};

			/**
			 * [tokenPost description]
			 * @param  {[type]}   url           [description]
			 * @param  {[type]}   data          [description]
			 * @param  {Function} callback      [description]
			 * @param  {[type]}   errorCallback [description]
			 * @return {[type]}                 [description]
			 */
			var tokenPost = function( url, data, callback, errorCallback )
			{
				url = url || false;
				data = data || {};
				callback = callback || function(){};
				errorCallback = errorCallback || function(){};
				$.ajax({
					url: url,
					type: 'post',
					data: data,
					headers: { 'X-CSRF-TOKEN' : window.MediaManager.csrfToken },
					dataType: 'json',
					success: callback,
					error : errorCallback
				});
			}

			/**
			 * [createFolder description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var createFolder = function(e)
			{
				( e ? e.preventDefault() : null );
				var folderName = $( '[data-name="folder-name"]', gmm.modal ).val();
				tokenPost( '/admin/media-manager/create-folder', { folder_name : folderName, folder_id : gmm.folder_id }, function( response ){
					$( '[data-name="folder-name"]', gmm.modal ).val('');
					cancelCreateNewFolder();
					getModalPartial( function( view ) {
						updateBrowserView( view );
					});
				}, function( error ) {
					console.log(error);
				});
			};

			/**
			 * [cancelUpdateFolder description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var cancelUpdateFolder = function(e)
			{
				( e ? e.preventDefault() : null );
				$( '[data-for="browse-panel"]' ).toggleClass( 'folder-edit-modal' );
				closeErrorMessage();
			};

			/**
			 * [updateFolder description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var updateFolder = function(e)
			{
				( e ? e.preventDefault() : null );
				var folderName = $( '[data-name="edit-folder-name"]', gmm.modal ).val();
				tokenPost( '/admin/media-manager/update-folder', { folder_name : folderName, folder_id : gmm.folder_editting }, function( response ){
					$( '[data-name="edit-folder-name"]', gmm.modal ).val('');
					cancelUpdateFolder();
					getModalPartial( function( view ) {
						updateBrowserView( view );
					});
				}, function( error ) {
					console.log(error);
				});
			};


			/**
			 * [checkGoToPreviousFolderButton description]
			 * @return {[type]} [description]
			 */
			var checkGoToPreviousFolderButton = function()
			{
				$( '[data-for="previous-folder"]', gmm.modal ).hide();
				if( gmm.previous_folder_id !== null ) {
					$( '[data-for="previous-folder"]', gmm.modal ).show();
				}
			};

			/**
			 * [getMediaInfo description]
			 * @param  {[type]}   id       [description]
			 * @param  {Function} callback [description]
			 * @return {[type]}            [description]
			 */
			var getMediaInfo = function( id, callback )
			{
				$.get( '/admin/media-manager/get-media-info/' + id, callback );
			};

			/**
			 * [getFolderInfo description]
			 * @param  {[type]}   id       [description]
			 * @param  {Function} callback [description]
			 * @return {[type]}            [description]
			 */
			var getFolderInfo = function( id, callback )
			{
				$.get( '/admin/media-manager/get-folder-info/' + id, callback );
			};

			/**
			 * [enterFolder description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var enterFolder = function(e)
			{
				( e ? e.preventDefault() : null );
				var card = $(this).parents( '[data-for="folder"]:eq(0)' );
				console.log(card);
				gmm.previous_folder_id = gmm.folder_id ;
				gmm.folder_id = parseInt( card.attr( 'data-id' ) );
				getModalPartial( function( view ) {
					updateBrowserView( view );
					scrollToTop( '[data-for="browse-panel"] > div' );
				});
			};

			/**
			 * [goToPreviousFolder description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var goToPreviousFolder = function(e)
			{
				( e ? e.preventDefault() : null );
				getFolderInfo( gmm.folder_id, function( model ) {
					gmm.folder_id = gmm.previous_folder_id;
					getModalPartial( function( view ) {
						showSpinner();
						getFolderInfo( gmm.folder_id, function( model ) {
							gmm.previous_folder_id = model.parent_id;
							if( gmm.folder_id == 0 ) gmm.previous_folder_id = null;
							updateBrowserView( view );
							hideSpinner();
						});
					});
				});
			};

			/**
			 * [goToFolder description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var goToFolder = function(e)
			{
				( e ? e.preventDefault() : null );
				var link = $(this);
				gmm.previous_folder_id = link.attr( 'data-folder-parent-id' );
				gmm.folder_id = link.attr( 'data-folder-id' );
				getModalPartial( function( view ) {
					showSpinner();
					getFolderInfo( gmm.folder_id, function( model ) {
						gmm.previous_folder_id = model.parent_id;
						if( gmm.folder_id == 0 ) gmm.previous_folder_id = null;
						updateBrowserView( view );
						hideSpinner();
					});
				});
			};

			/**
			 * [updateBrowserView description]
			 * @param  {[type]} view [description]
			 * @return {[type]}      [description]
			 */
			var updateBrowserView = function( view )
			{
				checkGoToPreviousFolderButton();
				gmm.browserView.html( '' );
				$( view ).appendTo( gmm.browserView );
				browserViewEvents();
			};

			/**
			 * [onCardDragStart description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var onCardDragStart = function(e)
			{
				var elm = $( e.target );
				gmm.cardBeingDragged = {
					elm : elm,
					id : elm.attr( 'data-media-id' ) ? elm.attr( 'data-media-id' ) : elm.attr( 'data-id' ),
					type : elm.attr( 'data-media-id' ) ? 'media' : 'folder'
				};
			};

			/**
			 * [deleteFolder description]
			 * @param  {[type]}   id       [description]
			 * @param  {Function} callback [description]
			 * @return {[type]}            [description]
			 */
			var deleteFolder = function( id, callback )
			{
				tokenPost( '/admin/media-manager/delete-folder', { id : id }, callback );
			};

			/**
			 * [deleteMedia description]
			 * @param  {[type]}   id       [description]
			 * @param  {Function} callback [description]
			 * @return {[type]}            [description]
			 */
			var deleteMedia = function( id, callback )
			{
				tokenPost( '/admin/media-manager/delete-media', { id : id }, callback );
			};

			/**
			 * [onCardDragDrop description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var onCardDragDrop = function(e)
			{
				$( '[data-for="delete-drop-zone"]', gmm.modal ).removeClass( 'ready-to-delete' );
				if( gmm.toBeDeleted ) {
                    console.log(gmm.toBeDeleted);
					switch( gmm.toBeDeleted.type ) {
						case 'folder' :
							deleteFolder( gmm.toBeDeleted.id, function( id ) {
								getModalPartial( function( view ) {
									updateBrowserView( view );
								});
							});
						break;
						case 'media' :
							deleteMedia( gmm.toBeDeleted.id, function( id ) {
								getModalPartial( function( view ) {
									updateBrowserView( view );
								});
							});
						break;
					}
					gmm.toBeDeleted = null;
				}
			};

			/**
			 * [dropzoneEnter description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var dropzoneEnter = function(e)
			{
				$( '[data-for="delete-drop-zone"]', gmm.modal ).addClass( 'ready-to-delete' );
				gmm.toBeDeleted = gmm.cardBeingDragged;
			};

			/**
			 * [dropzoneLeave description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var dropzoneLeave = function(e)
			{
				$( '[data-for="delete-drop-zone"]', gmm.modal ).removeClass( 'ready-to-delete' );
				gmm.toBeDeleted = null;
			};

			/**
			 * [cardEnterAnotherCard description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var cardEnterAnotherCard = function(e)
			{
				if( gmm.cardBeingDragged === null ) return;
				e.preventDefault(); e.stopPropagation();
				var destination = $( e.target ).closest( '[data-for="folder"]' );
				if( destination.get(0) === gmm.cardBeingDragged.elm.get(0) ) return;
				destination.addClass( 'ready-to-recieve' );
			};

			/**
			 * [cardLeaveAnotherCard description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var cardLeaveAnotherCard = function(e)
			{	
				if( gmm.cardBeingDragged === null ) return;
				var destination = $( e.target ).closest( '[data-for="folder"]' );
				if( destination.get(0) === gmm.cardBeingDragged.elm.get(0) ) return;
				destination.removeClass( 'ready-to-recieve' );
			};

			/**
			 * [moveFolderToFolder description]
			 * @param  {[type]}   itemID       [description]
			 * @param  {[type]}   destinationID [description]
			 * @param  {Function} callback     [description]
			 * @return {[type]}                [description]
			 */
			var moveFolderToFolder = function( itemID, destinationID, callback )
			{
				tokenPost( '/admin/media-manager/move-folder-to-folder', { item_id : itemID, destination_id : destinationID }, callback );
			};

			/**
			 * [moveMediaToFolder description]
			 * @param  {[type]}   itemID       [description]
			 * @param  {[type]}   destinationID [description]
			 * @param  {Function} callback     [description]
			 * @return {[type]}                [description]
			 */
			var moveMediaToFolder = function( itemID, destinationID, callback )
			{
				tokenPost( '/admin/media-manager/move-media-to-folder', { item_id : itemID, destination_id : destinationID }, callback );
			};

			/**
			 * [cardDropOnAnotherCard description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var cardDropOnAnotherCard = function(e)
			{
				var destination = $( e.target ).closest( '[data-for="folder"]' );
				if( ! destination.length ) return;
				var destinationID = parseInt( destination.attr( 'data-id' ) );
				if( destination.get(0) === gmm.cardBeingDragged.elm.get(0) ) return;
				destination.removeClass( 'ready-to-recieve' );
				switch( gmm.cardBeingDragged.type ) {
					case 'folder' :
						moveFolderToFolder( gmm.cardBeingDragged.id, destinationID, function(){
							if( gmm.search_bar.val() ) {
								getSearchModalPartial( gmm.search_bar.val(), function( view ) {
									searchRequest = null;
									updateBrowserView( view );
								});
							} else {
								getModalPartial( function( view ) {
									updateBrowserView( view );
								});
							}
						});
					break;
					case 'media' :
						moveMediaToFolder( gmm.cardBeingDragged.id, destinationID, function(){
							console.log(gmm.search_bar.val());
							if( gmm.search_bar.val() ) {
								getSearchModalPartial( gmm.search_bar.val(), function( view ) {
									searchRequest = null;
									updateBrowserView( view );
								});
							} else {
								getModalPartial( function( view ) {
									updateBrowserView( view );
								});
							}
						});
					break;
				}
				gmm.cardBeingDragged = null;
			};

			/**
			 * [preloadImages description]
			 * @return {[type]} [description]
			 */
			var preloadImages = function()
			{
				$( '[data-img-ref]', gmm.modal ).each( function() {
					var ref = $(this).attr( 'data-img-ref' );
					var src = $(this).attr( 'data-src' );
					if( typeof gmm.images[ref] === 'undefined' ) {
						var tmpImg = new Image( 300, 150 );
						tmpImg.jElm = $(this);
						tmpImg.addEventListener( "load", function() {
							this.jElm.attr( 'src', this.src );
						}, false);
						tmpImg.src = src;
						gmm.images[ref] = tmpImg;
					} else {
						$(this).attr( 'src', src );
					}
				});
			};

			/**
			 * [scrollToTop description]
			 * @param  {[type]} selector [description]
			 * @return {[type]}          [description]
			 */
			var scrollToTop = function( selector )
			{
				$( selector ).animate({ scrollTop: 0 }, 0 );
			};

			/**
			 * [useSelectedMediaFile description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var useSelectedMediaFile = function(e)
			{
				e.preventDefault();
				getMediaInfo( parseInt( $(this).parents( '[data-media-id]:eq(0)' ).attr( 'data-media-id' ) ), function( model ) {
					if( redactorInstance == null ) {
						elmBrowsing.selectedMedia( model );
						elmBrowsing = null;
					} else {
						if( $.inArray( model.extension, [ 'jpg', 'jpeg', 'gif', 'png' ] ) != -1 ) {
							redactorInstance.insert.html( '<img src="/admin/media-manager/image/' + model.name + '.' + model.extension + '" />' );
						} else {
							redactorInstance.insert.html( '<a href="/admin/media-manager/get/' + model.name + '.' + model.extension + '">' + model.name + '</a>' );
						}
					}
					api.close();
				});
			};

            /**
			 *
             * @param e
             */
			var useSelectedFolder = function(e)
			{
                e.preventDefault();
                getFolderInfo( parseInt( $(this).parents( '[data-id]:eq(0)' ).attr( 'data-id' ) ), function( model ) {
					elmBrowsing.selectedFolder( model );
					elmBrowsing = null;
                    api.close();
                });
			};

			/**
			 * [browserViewEvents description]
			 * @return {[type]} [description]
			 */
			var browserViewEvents = function()
			{
				$( '[data-for="enter-folder"]', gmm.modal ).bind( 'click.gmm', enterFolder );
				$( '[data-for="edit-details"]', gmm.modal ).bind( 'click.gmm', editDetailsModal );
				$( '[data-for="edit-folder"]', gmm.modal ).bind( 'click.gmm', editFolderModal );
				$( '.breadcrumb a.section', gmm.modal ).bind( 'click.gmm', goToFolder );
				$( '[data-for="select-media"]', gmm.modal ).bind( 'click.gmm', useSelectedMediaFile );
                $( '[data-for="select-folder"]', gmm.modal ).bind( 'click.gmm', useSelectedFolder );

				$( '[draggable="true"][data-for="card"], [draggable="true"][data-for="folder"]', gmm.modal )
					.bind( 'dragstart.gmm', onCardDragStart )
					.bind( 'drop.gmm', onCardDragDrop )
					.on( 'dragover dragenter', cardEnterAnotherCard )
					.on( 'dragleave dragend', cardLeaveAnotherCard )
					.on( 'drop', cardDropOnAnotherCard );

				$( '[data-html]', gmm.modal ).popup({
					inline : true,
					position : 'left center'
				});

				preloadImages();

			};

			/**
			 * [dropCardOnPreviousFolder description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var dropCardOnPreviousFolder = function(e)
			{
				$( '[data-for="previous-folder"]' ).removeClass( 'ready-to-recieve' );
				switch( gmm.cardBeingDragged.type ) {
					case 'folder' :
						moveFolderToFolder( gmm.cardBeingDragged.id, gmm.previous_folder_id, function(){
							getModalPartial( function( view ) {
								updateBrowserView( view );
							});
						});
					break;
					case 'media' :
						moveMediaToFolder( gmm.cardBeingDragged.id, gmm.previous_folder_id, function(){
							getModalPartial( function( view ) {
								updateBrowserView( view );
							});
						});
					break;
				}
				gmm.cardBeingDragged = null;
			};

			/**
			 * [enterPreviousFolderZone description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var enterPreviousFolderZone = function(e)
			{
				$( '[data-for="previous-folder"]' ).addClass( 'ready-to-recieve' );
			};

			/**
			 * [leavePreviousFolderZone description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var leavePreviousFolderZone = function(e)
			{
				$( '[data-for="previous-folder"]' ).removeClass( 'ready-to-recieve' );
			};

			/**
			 * [changeSearchFor description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var changeSearchFor = function(e)
			{
				gmm.search_for = parseInt( $(this).val() );
			};

			/**
			 * [handleSearchInput description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var handleSearchInput = function(e)
			{
				var value = $(this).val();
				if( searchRequest ) searchRequest.abort();

				if( value.length ) {
					getSearchModalPartial( value, function( view ) {
						searchRequest = null;
						updateBrowserView( view );
					}, globalErrorHandler );
				} else {
					getModalPartial( function( view ) {
						searchRequest = null;
						updateBrowserView( view );
					}, globalErrorHandler );
				}
			};	

			/**
			 * [triggerCreationOnEnterKey description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			var triggerCreationOnEnterKey = function(e)
			{
				var keycode = ( e.keyCode ? e.keyCode : e.which );
				if ( keycode == '13' ) {
					createFolder();
				}
			};

			/**
			 * [showSpinner description]
			 * @return {[type]} [description]
			 */
			var showSpinner = function()
			{
				gmm.loader.show();
			};

			/**
			 * [hideSpinner description]
			 * @return {[type]} [description]
			 */
			var hideSpinner = function()
			{
				gmm.loader.hide();
			};

            /**
			 * Set Focal Point Handler
             * @param e
             */
			var setFocalPointHandler = function(e)
			{
				e.preventDefault();
				var width = $(this).width();
				var height = $(this).height();
                var offset = $(this).offset();
                var top = e.pageY - offset.top;
                var left = e.pageX - offset.left;
                var y = Number( 100 / ( height / top ) ).toFixed(0);
                var x = Number( 100 / ( width / left ) ).toFixed(0);
				$('.focal-pointer').css({
					top: y + '%',
					left: x + '%'
				});
                $('[data-for="x-focal-point"]').val(x);
                $('[data-for="y-focal-point"]').val(y);
			};

			/**
			 * [bindModalEvents description]
			 * @return {[type]} [description]
			 */
			var bindModalEvents = function()
			{
				gmm.closeButton.bind( 'click.gmm', closeModal );
				$( '[data-for="search-for"]', gmm.modal ).bind( 'change.gmm', changeSearchFor ).val();
				gmm.search_bar.bind( 'keyup.gmm', handleSearchInput );
				$( '[data-content]', gmm.modal ).popup({
					position : 'top center',
					inline : true
				});
				$( '.ui.progress', gmm.modal ).progress();
				$( '[data-name="tags"]', gmm.modal ).tagsInput({
					height : 'auto',
					width : '100%'
				});
				$( '.close.icon', gmm.error ).bind( 'click.gmm', closeErrorMessage );
				
				$( '[data-for="previous-folder"]', gmm.modal ).bind( 'click.gmm', goToPreviousFolder );
				$( '[data-for="toggle-view"]', gmm.modal ).bind( 'click.gmm', toggleView );
				$( '[data-for="cancel-save-details"]', gmm.modal ).bind( 'click.gmm', cancelSaveDetails );
				$( '[data-for="create-new-folder"]', gmm.modal ).bind( 'click.gmm', createNewFolder );
				$( '[data-for="cancel-create-folder"]', gmm.modal ).bind( 'click.gmm', cancelCreateNewFolder );
				$( '[data-for="cancel-edit-folder"]', gmm.modal ).bind( 'click.gmm', cancelUpdateFolder );
				$( '[data-name="folder-name"]', gmm.modal ).bind( 'keydown.gmm', triggerCreationOnEnterKey );
				$( '[data-for="create-folder"]', gmm.modal ).bind( 'click.gmm', createFolder );
				$( '[data-for="update-folder"]', gmm.modal ).bind( 'click.gmm', updateFolder );
				$( '[data-for="save-media"]', gmm.modal ).bind( 'click.gmm', saveMedia );
				$( '#single-upload', gmm.modal ).bind( 'change.gmm', singleFileUploadHandler );	

				$( '[data-for="delete-drop-zone"]', gmm.modal ).on( 'drag dragstart dragend dragover dragenter dragleave drop', function(e) {
					e.preventDefault(); e.stopPropagation();
				})
				.on( 'dragover dragenter', dropzoneEnter )
				.on( 'dragleave dragend', dropzoneLeave )
				.on( 'drop', onCardDragDrop );

				$( '[data-for="previous-folder"]', gmm.modal ).on( 'drag dragstart dragend dragover dragenter dragleave drop', function(e) {
					e.preventDefault(); e.stopPropagation();
				})
				.on( 'dragover dragenter', enterPreviousFolderZone )
				.on( 'dragleave dragend', leavePreviousFolderZone )
				.on( 'drop', dropCardOnPreviousFolder );

				$('[data-for="right-media-manager-panel"]').on( 'click', '[data-for="focal-point-img"]', setFocalPointHandler );

				browserViewEvents();

				gmm.dropZone.on( 'drag dragstart dragend dragover dragenter dragleave drop', function(e) {
					e.preventDefault(); e.stopPropagation();
				})
				.on( 'dragover dragenter', function() {
					$(this).addClass( 'is-dragover' );
				})
				.on( 'dragleave dragend drop', function() {
					$(this).removeClass( 'is-dragover' );
				})
				.on( 'drop', handleDroppedFiles );
			};

			/**
			 * [unbindModalEvents description]
			 * @return {[type]} [description]
			 */
			var unbindModalEvents = function()
			{
				gmm.closeButton.unbind( 'click.gmm', closeModal );
			};

			/**
			 * [getModalView description]
			 * @param  {Function} callback [description]
			 * @return {[type]}            [description]
			 */
			var getModalView = function( callback, failCallback )
			{
				failCallback = failCallback || function(){};
				$.get( '/admin/media-manager/global/init', { 
					folder_id : gmm.folder_id, 
					view : gmm.current_view, 
					is_browsing : ( elmBrowsing === null ? 0 : 1 ),
					file_type_restrictions : fileTypeRestrictions,
                    folderSelect : gmm.foldersSelect
				} , function( response )
				{
					callback( response );
					hideSpinner();
				})
				.fail( failCallback );
			};

			/**
			 * [getModalPartial description]
			 * @param  {Function} callback [description]
			 * @return {[type]}            [description]
			 */
			var getModalPartial = function( callback, failCallback )
			{
				failCallback = failCallback || function(){};
				showSpinner();
				$.get( '/admin/media-manager/global/partial', { 
					folder_id : gmm.folder_id, 
					view : gmm.current_view, 
					is_browsing : ( elmBrowsing === null ? 0 : 1 ),
					file_type_restrictions : fileTypeRestrictions,
                    folderSelect : gmm.foldersSelect
				} , function( response )
				{
					hideSpinner();
					callback( response );
				})
				.fail( failCallback );
			};

			/**
			 * [getSearchModalPartial description]
			 * @param  {[type]}   search_value [description]
			 * @param  {Function} callback     [description]
			 * @return {[type]}                [description]
			 */
			var getSearchModalPartial = function( search_value, callback, failCallback )
			{
				failCallback = failCallback || function(){};
				showSpinner();
				searchRequest = $.get( '/admin/media-manager/global/search-partial', { 
					folder_id 		: gmm.folder_id, 
					view 			: gmm.current_view,  
					search_value 		: search_value,
					search_for 		: gmm.search_for,
					file_type_restrictions 	: fileTypeRestrictions,
					is_browsing 		: ( elmBrowsing === null ? 0 : 1 ),
                    folderSelect : gmm.foldersSelect
				}, function( response ) {
					hideSpinner();
					callback( response );
				})
				.fail( failCallback );
			};

			/**
			 * [globalErrorHandler description]
			 * @param  {[type]} response [description]
			 * @return {[type]}          [description]
			 */
			var globalErrorHandler = function( response )
			{
				switch( response.status ) {
					case 401 : 
						switch( response.statusText ) {
							case 'Unauthorized' :
								window.location.reload();
							break;
						}
					break;
				}
			};

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			var init = function() 
			{
				getModalView( function( view ) {
					$( view ).appendTo( gmm.modal );
					gmm.closeButton = $( '[data-for="close-media-manager"]', gmm.modal );
					gmm.dropZone = $( '[data-for="upload-pad"]', gmm.modal );
					gmm.uploadList = $( '[data-for="upload-list"]', gmm.dropZone );
					gmm.browserView = $( '[data-for="browser view"]', gmm.modal );
					gmm.search_bar = $( '[data-for="search"]', gmm.modal );
					gmm.loader = $( '[data-for="spinner"]', gmm.modal );
					gmm.error = $( '[data-for="errors"]', gmm.modal ).fadeOut(0);
					bindModalEvents();
					$( '.browse.ui.form.loading.area', gmm.modal ).removeClass( 'loading' );
				});
			};

			/**
			 * [api description]
			 * @return {[type]} [description]
			 */
			var _api = function( _gmm ) {

				/**
				 * [open description]
				 * @return {[type]} [description]
				 */
				this.open = function()
				{
					getModalPartial( function( view ) {
						updateBrowserView( view );
					}, globalErrorHandler );
					_gmm.overlay.fadeIn(200);
					_gmm.modal.fadeIn(200);
				};

				/**
				 * [close description]
				 * @return {[type]} [description]
				 */
				this.close = function()
				{
					redactorInstance = null;
					fileTypeRestrictions = [];
                    _gmm.foldersSelect = false;
					_gmm.overlay.fadeOut(200);
					_gmm.modal.fadeOut(200, function(){
						api.removeBrowser();
					});
				};

				/**
				 * [destroy description]
				 * @return {[type]} [description]
				 */
				this.destroy = function() 
				{
					_gmm.overlay.remove();
					_gmm.modal.remove();
				};

				/**
				 * [setBrowser description]
				 * @param {[type]} jElm [description]
				 */
				this.setBrowser = function( jElm )
				{
					elmBrowsing = jElm;
					_gmm.modal.addClass( 'browsing-only' );
					api.open();
				};

				this.folderSelect = function()
				{
					_gmm.foldersSelect = true;
				};

                /**
				 *
                 * @param id
                 * @param callback
                 */
				this.getMediaInfo = function( id, callback )
				{
					getMediaInfo( id, callback );
				};

                /**
				 *
                 * @param id
                 * @param callback
                 */
                this.getFolderInfo = function( id, callback )
                {
                    getFolderInfo( id, callback );
                };

				/**
				 * [removeBrowser description]
				 * @return {[type]} [description]
				 */
				this.removeBrowser = function()
				{
					elmBrowsing = null;
					_gmm.modal.removeClass( 'browsing-only' );
				};

				/**
				 * [setFileTypeRestrictions description]
				 * @param {[type]} array [description]
				 */
				this.setFileTypeRestrictions = function( array )
				{
					fileTypeRestrictions = array;
				};

				/**
				 * [setRedactorInstance description]
				 * @param {[type]} redactor [description]
				 */
				this.setRedactorInstance = function( redactor )
				{
					redactorInstance = redactor;
				};

			};

			api = new _api( gmm );
			init();
			return api;

		};

		if( typeof document.MMGLOB === 'undefined' ) {
			document.MMGLOB = new GlobalMediaManager();
		}

		if( ! $(this).length && typeof input === 'string' ) {
			switch( input ) {
				case 'open' : 
					return document.MMGLOB.open();
				break;
				case 'desroy' :
					return document.MMGLOB.desroy();
				break;
			}
		} else {
			return $(this).each( function() {
				return new MediaManager( this, input );
			});
		}

	};

	/**
	 * [advanced description]
	 * @return {[type]} [description]
	 */
	$.Redactor.prototype.mediaManager = function()
	{
		return {
			init: function () {
				var button = this.button.add( 'mediaManager', 'Media Manager' );
				this.button.setAwesome( 'mediaManager', 'fa-picture-o' );
				this.button.addCallback( button, this.mediaManager.openMediaManager );
				this.mediaPlaceholder = $( '<input />' ).attr( 'type', 'hidden' ).insertAfter( this.$editor ).mediaManager({ restrictions: false });
				this.mediaPlaceholder.data( 'MMSINGLE' ).placeholder.hide();
			},
			openMediaManager: function( buttonName ) {
				document.MMGLOB.setRedactorInstance( this );
				this.mediaPlaceholder.data( 'MMSINGLE' ).browse.trigger( 'click.gmm' );
			}	
		};
	};

	$(document).ready( function(){
		$( '[data-for="media-attachment"]' ).mediaManager();
	});

})( window, document );
